module.exports = __webpack_public_path__ + "img/20200501_160424.85426c16.jpg";